import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { SearchResultsStore } from 'stores/search-results-store';

import { ToolbarType, UitkToolbar } from 'uitk-react-toolbar';
import { UitkFullscreenDialog } from 'uitk-react-dialog';

import { SearchForm } from 'components/common/search-form/index';

export interface ChangeSearchDialogProps extends LocalizedComponentProps {
  afterSubmit?: ({ queryString: string }) => void;
  analytics?: {
    setupTracker: (id: string, description: string) => { id; description; callback };
  };
  onDismiss: () => void;
  onUpdateResults?: () => void;
  searchResults?: SearchResultsStore;
}
@withLocalization
export class ChangeSearchDialog extends React.Component<ChangeSearchDialogProps> {
  constructor(props: ChangeSearchDialogProps) {
    super(props);

    this.onDismiss = this.onDismiss.bind(this);
  }

  public onDismiss() {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  }

  public render() {
    const toolBarAttributes = {
      iconLabel: this.props.l10n.formatText('hotels.searchResults.cancelButton.a11yLabel'),
      header: this.props.l10n.formatText('hotels.searchResults.title'),
      type: ToolbarType.CLOSE
    };

    const { searchResults, analytics } = this.props;

    const toolbarAnalytics = analytics.setupTracker(':CancelSearch', 'Cancel search form');

    const dialogProps = {
      dialogShow: true,
      className: 'search-form-overlay'
    };

    const searchResultsCriteria = searchResults && searchResults.searchCriteria;
    const changeSearch = searchResults.searchAndFilterDisplayOptions && searchResults.searchAndFilterDisplayOptions.changeSearch;
    const displayFields = changeSearch && changeSearch.displayFields;
    const ignoreFields = changeSearch && changeSearch.ignoreFields;

    return (
      <UitkFullscreenDialog {...dialogProps}>
        <UitkToolbar {...toolBarAttributes} analytics={toolbarAnalytics} action={this.onDismiss} />
        <section className="search-form-overlay-main">
          <div className="all-x-padding-two all-y-padding-two" data-stid="section-hotel-search">
            <SearchForm
              className="uitk-grid all-x-gutter-two all-y-gutter-two"
              model={searchResultsCriteria}
              formAction="/Hotel-Search"
              displayFields={displayFields}
              ignoreFields={ignoreFields}
            />
          </div>
        </section>
      </UitkFullscreenDialog>
    );
  }
}
